import { Button } from '@chakra-ui/button';
import { Flex, FlexProps, Text } from '@chakra-ui/layout';
import { Icon, IconButton } from '@chakra-ui/react';
import React from 'react';
import { ArrowLeft, ArrowRight } from 'react-feather';

interface PaginationProps {
  items: any[] | null;
  onPageChange: (p: number) => void;
  currentPage: number;
  containerProps?: FlexProps;
}

export const Pagination: React.FC<PaginationProps> = ({
  items,
  onPageChange,
  currentPage,
  containerProps,
}) => {
  const pagination = items && new Array(Math.ceil(items.length / 10)).fill(0);
  return (
    <Flex align="center" justify="flex-end" {...containerProps}>
      <Text>Seite</Text>
      {pagination &&
        pagination.length > 0 &&
        (pagination.length > 5 ? (
          <>
            <IconButton
              aria-label="zurück"
              borderRadius="xl"
              isDisabled={currentPage <= 1}
              ml={2}
              onClick={() => onPageChange(currentPage - 1)}
              icon={<Icon as={ArrowLeft} />}
            />
            <Text w="70px" textAlign="center">
              {currentPage}/{pagination.length}
            </Text>
            <IconButton
              aria-label="weiter"
              borderRadius="xl"
              ml={2}
              onClick={() => onPageChange(currentPage + 1)}
              isDisabled={(items && currentPage >= pagination?.length) || false}
              icon={<Icon as={ArrowRight} />}
            />
          </>
        ) : (
          pagination.map((_, page) => (
            <Button
              borderRadius="xl"
              ml={2}
              colorScheme={page + 1 === currentPage ? 'brand' : 'gray'}
              onClick={() => onPageChange(page + 1)}
              key={`page${page.toString()}`}
            >
              {page + 1}
            </Button>
          ))
        ))}
      {pagination && pagination.length <= 0 && (
        <Button borderRadius="xl" ml={2} colorScheme="brand">
          1
        </Button>
      )}
    </Flex>
  );
};
